import { createIcon } from './create-icon';

export const CrownIcon = createIcon(
  'CrownIcon',
  <>
    <path d="M2 19h20" />
    <path d="M5 19L3 8l4.5 3L12 4l4.5 7L21 8l-2 11" />
  </>,
);
